import React from "react";
import { Query } from "react-apollo";
import { Dropdown } from "semantic-ui-react";
import { PROGRAMS_DROPDOWN } from "../../../graphql/queries/programs";

export default ({
  selectedOrganismId,
  selectedInstitutionId,
  name,
  value,
  onChange,
  placeholder,
  clearable
}) => {
  return (
    <Query
      variables={{
        organismId: selectedOrganismId,
        institutionId: selectedInstitutionId
      }}
      query={PROGRAMS_DROPDOWN}
      fetchPolicy="no-cache">
      {({ loading, error, data }) => {

        if (loading)
          return "Loading...";
        if (error)
          return `Error! ${error.message}`;

        const options = data.programs.map(({ id, name }) => (
          { value: id, text: name, key: id }
        ));

        return (
          <Dropdown
            selection
            clearable={clearable || false}
            options={options}
            name={name}
            value={value}
            onChange={onChange}
            placeholder={placeholder} />
        );
      }}
    </Query>
  );
};
